import $ from 'jquery';
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import './gallery.scss';
import _ from 'lodash';

const VIDEO_SLIDE_CLASS = 'gallery-video';

export default function () {
    const playPauseVideoPlayer = (swiper) => {
        const isVideoSlide = _.includes(_.get(swiper, 'clickedSlide.classList', []), VIDEO_SLIDE_CLASS);
        const video = _.get(window, "videojs.players.VideoPlayerFullScreen", { play: _.noop, pause: _.noop });

        if (isVideoSlide) {
            video.play();
        } else {
            video.pause();
        }
    };

    const galleryTop = new Swiper('.gallery-top', {
        preloadImages: false,
        longSwipes: false,
        lazyLoading: true,
        nextButton: '.gallery-button-next',
        prevButton: '.gallery-button-prev',
        onSlideChangeStart: function (swiper) {
            $(galleryThumbs.slides).removeClass('is-selected');
            $(galleryThumbs.slides).eq(swiper.activeIndex).addClass('is-selected');
            playPauseVideoPlayer(swiper);
            galleryThumbs.slideTo(swiper.activeIndex - 2, 150, false);
        }
    });

    const galleryThumbs = new Swiper('.gallery-thumbs', {
        preloadImages: false,
        lazyLoading: true,
        spaceBetween: 10,
        freeMode: false,
        centeredSlides: false,
        slidesPerView: 5,
        shortSwipes: false,
        longSwipes: false,
        touchRatio: 0.2,
        onClick: function (swiper, event) {
            if (!$(event.target).is('.swiper-img')) return;
            $(swiper.slides).removeClass('is-selected');
            $(swiper.clickedSlide).addClass('is-selected');
            galleryTop.slideTo(swiper.clickedIndex, 150, false);
            playPauseVideoPlayer(swiper);
            galleryThumbs.slideTo(swiper.clickedIndex - 2, 150, false);
        },
        onInit: function (swiper) {
            $('.row.thumbs').css({ 'opacity': 1 });
            if (swiper.slides.length <= 5) {
                $('#gallery .button-wrapper').hide();
                $('#gallery .thumbs-wrapper').css('width', '100%');
                swiper.update();
            }
        }
    });
}



// WEBPACK FOOTER //
// ./resources/modules/shared/Gallery/index.js